module.exports = __webpack_public_path__ + "static/assets/68bf3b7d85ca6408800a4240c1df9c33.svg";